import { AnyAction } from 'redux';

/* eslint-disable no-unused-vars */
export const SERVICE_ACTION_KEY = '_service_action_key_';

export interface CreateServiceActionParams {
  do: () => Promise<any>;
  doAction: string;
  doActionPayload?: any;
  successAction?: string;
  errorAction?: string;
  errorHandler?: (params: any) => void;
}

interface ServiceAction extends AnyAction {
  [SERVICE_ACTION_KEY]: boolean | undefined;
}

const createServiceAction = (
  params: CreateServiceActionParams,
  type = typeof SERVICE_ACTION_KEY
): ServiceAction => ({
  ...params,
  [SERVICE_ACTION_KEY]: true,
  type
});

export default createServiceAction;
